import { render, staticRenderFns } from "./DfrAggregate.vue?vue&type=template&id=3b4344cf&scoped=true"
import script from "./DfrAggregate.vue?vue&type=script&lang=js"
export * from "./DfrAggregate.vue?vue&type=script&lang=js"
import style0 from "./DfrAggregate.vue?vue&type=style&index=0&id=3b4344cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4344cf",
  null
  
)

export default component.exports